
import { useRouteWithLang } from "@/composables/useRouteWithLang";
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    to: { type: Object },
  },
  setup() {
    const { buildRouteWithLang } = useRouteWithLang();
    return { buildRouteWithLang };
  },
});
